import React, {
  FC,
  useEffect,
  useReducer,
  useRef,
  useContext,
  useState,
  useLayoutEffect,
  memo,
  useMemo,
  useCallback,
} from "react";
// import Select from "react-select";
// import { useLocation } from "react-router-dom";

import useFetch from "src/hooks/useFetch";
import { LoaderContext } from "src/context/loaderContext";
import { AuthContext } from "src/context/authContext";

import {
  ActionDashboardProps,
  ActionStatisticsDashboardActionType,
  PatientFilterState,
  PatientFilterStateActions,
  TodoResponseType,
} from "src/pages/actionDashboard/types";
import { tableFilterReducer } from "src/pages/actionDashboard/reducer";
import FooterText from "../../footerText";
import { format } from "date-fns";
import { downloadExcelFile } from "src/helpers/downloadFile";
import { APIEndpoints } from "src/types/apiTypes";

/* -------------------------------------------------- */
/* CONSTANTS */
/* -------------------------------------------------- */

const DEFAULT_TAB = "coverage_available";

/* -------------------------------------------------- */
/* COMPONENT */
/* -------------------------------------------------- */

const ActionDashboard: FC<ActionDashboardProps> = ({
  apiEndpoint,
  userListEndpoint,
  initialState,
  tabs,
  FilterComponent,
  allowedRoles,
}) => {
    
  const [queryParams, dispatch] = useReducer(tableFilterReducer, initialState);
  const { setLoader, hideLoader, isVisible } = useContext(LoaderContext);
  const { userData } = useContext(AuthContext);
  // const location = useLocation();

  const [activeTab, setActiveTab] = useState<string>(DEFAULT_TAB);
  const firstFetch = useRef(true);

  /* -------------------------------------------------- */
  /* FETCH (MANUAL MODE) */
  /* -------------------------------------------------- */

  const {
    data: dashboardData,
    error: dashboardError,
    mutate: updateData,
    removeErrorAndData: clearDashboardData
  } = useFetch<TodoResponseType>(apiEndpoint, {}, {}, false);



  const {
    data: downloadFileData,
    error: downloadFileError,
    mutate: updateFileData,
    removeErrorAndData: clearFileData
  } = useFetch<TodoResponseType>(APIEndpoints.TODO_ACTION_DASHBOARD_STATISTICS_FILE_DOWNLOAD, {}, {}, false);

  useEffect(() => {
    if (downloadFileError || downloadFileData) {
      if (isVisible) {hideLoader()}
      if (downloadFileData ) {
        //console.log("DashboardData for export....", downloadFileData          )

        //setExportingInProgressStatus(false);
        if(downloadFileData.data.response && downloadFileData.data.report_name){
          //console.log("DashboardData for export....", dashboardData)
          downloadExcelFile(downloadFileData.data.response, `${downloadFileData.data.report_name}.xlsx`);
        }
    }}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [downloadFileError, downloadFileData])

  /* -------------------------------------------------- */
  /* INITIAL LOADER */
  /* -------------------------------------------------- */

  useLayoutEffect(() => {
    setLoader();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  

  /* --------------------------------------------------
    CHECK ON RESPONSE IF DATA IS AVAILABLE TO DISABLE THE LOADER
  -------------------------------------------------- */
  useEffect(() => {
    if (dashboardError || dashboardData) {
      if (isVisible) {hideLoader()}
      if (dashboardData ) {
        //console.log("DashboardData for export....", dashboardData)
hideLoader()
        //setExportingInProgressStatus(false);
        
    }}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardError, dashboardData])

  /* -------------------------------------------------- */
  /* FETCH HELPER (SINGLE SOURCE OF TRUTH) */
  /* -------------------------------------------------- */


  const normalizeToArray = (value?: string | string[]) => {
    if (!value) return [];
    if (Array.isArray(value)) return value;
    return value.split("&").map(v => v.trim());
  };
  const fetchTabData = useCallback(
    (tabKey: string, extraParams: Partial<PatientFilterState> = {}) => {
      setLoader();
     // console.log("TabKey....", tabKey, "sabfjvsadhvfhsd", queryParams,"extraParams....",extraParams)
      if (!userData) return;

      const finalParams = {
        ...queryParams,
        ...extraParams,
        role: userData.ref_type,
        //id: userData.id,
        //section: tabKey,
        // start_date:queryParams.start_date,
        // end_date:queryParams.end_date,
        region: normalizeToArray(extraParams?.region),
        state: normalizeToArray(extraParams?.state),
        territory: normalizeToArray(extraParams?.territory),
        cas: normalizeToArray(extraParams?.cas),
        rsd: normalizeToArray(extraParams?.rsd),

        // drug_id: isZilrettaUser(userData)
        //   ? "zilretta"
        //   : queryParams.drug_id,
        drug_id:  extraParams.drug_id || "",
        id: userData.id.toString(),
        section: tabKey as unknown as "coverage_available" | "action_required" | "pending" | "specialty_pharmacy" | "copay_claims",
        // ...(tabKey !== queryParams.section ? {
        //   start_date: tabKey.includes("copay_claims") ? format((new Date()).setDate((new Date()).getDate() - 90), "yyyy-MM-dd") : format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),

        // } : {
        // }),
        //drug_id: isZilrettaUser(userData) ? "zilretta" : isIoveraUser(userData)? "iovera°" : queryParams.drug_id,
      };
      const finalParamsforDispatch = {
        ...queryParams,
        ...extraParams,
        ...finalParams,
        region: extraParams?.region,
        state: extraParams?.state,
        territory: extraParams?.territory,
        cas: extraParams?.cas,
        rsd: extraParams?.rsd,
        // start_date:extraParams.start_date || queryParams.start_date,
        // end_date:extraParams.end_date || queryParams.end_date,
        
        //drug_id: isZilrettaUser(userData) ? "zilretta" : isIoveraUser(userData)? "iovera°" : queryParams.drug_id,
      };
      setLoader();
      clearDashboardData();
      dispatch({
        type: PatientFilterStateActions.SET_QUERY_PARAMS,
        payload: finalParamsforDispatch,
      });
      //console.log("finalParams....", finalParams, "  ", finalParamsforDispatch)
      dispatch({
        type: PatientFilterStateActions.SET_QUERY_PARAMS,
        payload: finalParamsforDispatch,
      });
      updateData({}, {}, finalParams);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [queryParams, updateData, userData, setLoader]
  );

  /* -------------------------------------------------- */
  /* DEFAULT FETCH (ONCE) */
  /* -------------------------------------------------- */

  useEffect(() => {
    if (userData && firstFetch.current) {
      firstFetch.current = false;
      fetchTabData(DEFAULT_TAB);
    }
  }, [userData, fetchTabData]);

  /* -------------------------------------------------- */
  /* HIDE LOADER */
  /* -------------------------------------------------- */

  // useEffect(() => {
  //   if (dashboardData || dashboardError) {
  //     hideLoader();
  //   }
  // }, [dashboardData, dashboardError, hideLoader]);

  /* -------------------------------------------------- */
  /* TAB HANDLER */
  /* -------------------------------------------------- */

  const handleTabClick = (tabKey: string) => {
    console.log("Tab Clicked....", tabKey, activeTab)
    if (tabKey !== activeTab) {

      const resetPages = resetAllPagesToFirst(tabKey);
      //console.log("Reset Pages....", resetPages)
      dispatch({
        type: PatientFilterStateActions.SET_QUERY_PARAMS,
        payload: {
          ...queryParams,
          ...resetPages,
          // start_date: queryParams.start_date,
          // end_date: queryParams.end_date,
          //start_date: tabKey.includes("copay_claims") ? format((new Date()).setDate((new Date()).getDate() - 90), "yyyy-MM-dd") : format((new Date()).setDate((new Date()).getDate() - 30), "yyyy-MM-dd"),
          //drug_id:isZilrettaUser(userData) ? "zilretta": isIoveraUser(userData)?"iovera°":queryParams.drug_id ? queryParams.drug_id: "",
        },
      });
      //console.log("queryParams....", queryParams)
      setActiveTab(tabKey);
      //fetchTabData(tabKey);
      fetchTabData(tabKey, { ...resetPages, drug_id: queryParams.drug_id, region: queryParams.region, territory: queryParams.territory, state: queryParams.state, cas: queryParams.cas, rsd: queryParams.rsd });


    }
  };

  /* -------------------------------------------------- */
  /* PAGINATION */
  /* -------------------------------------------------- */

  const activeTabObj = tabs.find((t) => t.key === activeTab)!;

  const handlePageChange = useCallback(
    (pageObj: { selected: number }) => {
      //console.log("Page Changed...", pageObj.selected, "    ", queryParams.drug_id);
      const action: ActionStatisticsDashboardActionType = {
        type: activeTabObj.changeAction as unknown as any,
        payload: pageObj.selected + 1,
      };

      dispatch(action);

      fetchTabData(activeTab, {
        [activeTabObj.pageKey]: pageObj.selected + 1, drug_id: queryParams.drug_id, region: queryParams.region, territory: queryParams.territory, state: queryParams.state, cas: queryParams.cas, rsd: queryParams.rsd
      });
    },
    [activeTab, activeTabObj, fetchTabData]
  );

  const resetAllPagesToFirst = useCallback(
    (activeTabKey: string) => {
      const resetPages: Partial<PatientFilterState> = {};

      tabs.forEach((tab) => {
        (resetPages as any)[tab.pageKey] = 1;
      });

      // ensure active tab is also explicitly 1
      (resetPages as any)[
        tabs.find((t) => t.key === activeTabKey)!.pageKey
      ] = 1;

      return resetPages;
    },
    [tabs]
  );
  /* -------------------------------------------------- */
  /* FILTER HANDLER */
  /* -------------------------------------------------- */

  const updateQueryParamsAndCallAPI = (updatedQueries: PatientFilterState) => {

    dispatch({
      type: PatientFilterStateActions.SET_QUERY_PARAMS,
      payload: updatedQueries,
    });
    //console.log("updatedQueries.....in updateQueryParamsAndCallAPI", updatedQueries)
    fetchTabData(activeTab, updatedQueries);
  };

  /* -------------------------------------------------- */
  /* TABLE DATA */
  /* -------------------------------------------------- */

  const tableData = useMemo(
    () => activeTabObj.dataSelector(dashboardData?.data ?? {}),
    [dashboardData, activeTabObj]
  );

  /* -------------------------------------------------- */
  /* RENDER */
  /* -------------------------------------------------- */

  
    const downloadFile = () => {
    //(true)
    setLoader();
      // if (!userData) return;

      const finalParams = {
        ...queryParams,
        region: normalizeToArray(queryParams?.region),
        state: normalizeToArray(queryParams?.state),
        territory: normalizeToArray(queryParams?.territory),
        cas: normalizeToArray(queryParams?.cas),
        rsd: normalizeToArray(queryParams?.rsd),

      };
      // const finalParamsforDispatch = {
      //   ...queryParams,
      //   ...extraParams,
      //   ...finalParams,
      //   region: extraParams?.region,
      //   state: extraParams?.state,
      //   territory: extraParams?.territory,
      //   //drug_id: isZilrettaUser(userData) ? "zilretta" : isIoveraUser(userData)? "iovera°" : queryParams.drug_id,
      // };
      // setLoader();
      clearFileData();
      dispatch({
        type: PatientFilterStateActions.SET_QUERY_PARAMS,
        payload: queryParams,
      });
      //console.log("finalParams....", finalParams, "  ", finalParamsforDispatch)
      updateFileData({}, {}, {...finalParams,file_required: "true"});
    //if (caseError || caseObject) clearCaseState();
    //setLoader();
    //const newState =  {...queryParams};
    //console.log("Exporting with params....", activeTab, "   ", newState )
    // newState.start_date = newState.start_date ? format(parse(newState.start_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd") : ""
    // newState.end_date = newState.end_date ? format(parse(newState.end_date, "MM/dd/yyyy", new Date()), "yyyy-MM-dd") : ""
   // fetchTabData(activeTab, queryParams);

    //getCaseListing(null, null, newState);
    //getCaseListing({}, {}, { ...newState, pagination: false })
  }
  return (
    <section className="overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill action-dashboard">
      <div className="container-fluid pt-3 d-flex flex-column flex-fill">
        <h2 className="page-heading mb-3">Action Dashboard</h2>

        {/* Filters */}
        <FilterComponent
          doctorDropdown={dashboardData?.data?.doctor_dropdown ?? []}
          practiceDropdown={dashboardData?.data?.practice_dropdown ?? []}
          region_dropdown={dashboardData?.data?.region_dropdown ?? []}
          territory_dropdown={dashboardData?.data?.territory_dropdown ?? []}
          state_dropdown={dashboardData?.data?.state_dropdown ?? []}
          cas_dropdown={dashboardData?.data?.cas_dropdown ?? []}
          rsd_dropdown={dashboardData?.data?.rsd_dropdown ?? []}
          defaultQueryParams={queryParams}
          updateQueryParams={updateQueryParamsAndCallAPI}
          activeTab={activeTabObj.key}
        />

        {/* Tabs */}
        {/* <div className="nav nav-pills mb-3 mt-2 gap-2 bg-dark">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
              onClick={() => handleTabClick(tab.key)}
              type="button"
            >
              {tab.label}
            </button>
          ))}
        </div> */}
        <div className="d-flex justify-content-between align-items-center p-2 rounded">

          {/* Tabs */}
          <div className="nav nav-pills gap-2">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                className={`nav-link ${activeTab === tab.key ? "active" : ""}`}
                onClick={() => handleTabClick(tab.key)}
                type="button"
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Export Button */}
          <div>
            <button
              type="button"
              className="btn btn-success rounded"
              onClick={downloadFile} // your export function
            >
              Export
            </button>
          </div>

        </div>

        {/* Content */}
        <div className="card flex-fill">
          <div className="card-body p-0 d-flex flex-column">
            <activeTabObj.Component
              tableData={tableData}
              currentPage={queryParams[activeTabObj.pageKey]}
              onPageChange={handlePageChange}
              refreshListing={() => fetchTabData(activeTab)}
            />
          </div>
        </div>
      </div>

      <FooterText footerType="black" />
    </section>
  );
};

export default memo(ActionDashboard);
